import { render, staticRenderFns } from "./VueGoogleAutocomplete.vue?vue&type=template&id=47a93b2d&"
import script from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports